<template>
  <div class="block-text-image__main">
      <div class="block-text-image__head">
        <div class="not-found">
            <img src="@/assets/images/logos/404.svg" class="not-found" />
          <h1 class="text-sidebar__title">{{ $t('pageNotFound.title') }}</h1>
          <p>{{ $t('pageNotFound.content') }}</p>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'PageNotFound',
};
</script>
<style scoped>
.not-found{
  text-align: center;
}
.not-found img{
  max-width: 400px;
}
</style>
